var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('Toolbar',{attrs:{"app":""}}),_c('v-container',{attrs:{"fill-height":"","fluid":"","pa-0":""}},[_c('router-view',{key:_vm.$route.path,style:(_vm.$route.path !== '/register' &&
        _vm.$route.path !== ("/register/" + (_vm.$route.params.token)) &&
        _vm.$route.path !== '/login' &&
        _vm.$route.path !== ("/login/" + (_vm.$route.params.token)) &&
        _vm.$route.path !== ("/reset-password/" + (_vm.$route.params.token)) &&
        _vm.$route.path !== '/forgot-password' ? 'margin-top: -180px; padding-top: 180px !important;' : '')})],1),_c('Footer',{attrs:{"app":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }